import axios from "axios";

const API = axios.create({
    baseURL: 'https://bo.kapadiaglobal.in/api',
});

export default API;